import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vodnice_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { API };

// Normalizes any API error (incl. FastAPI/Pydantic 422 arrays/objects) into a safe display string.
export function getApiError(e, fallback = "Něco se nepovedlo. Zkuste to prosím znovu.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (typeof x === "string" ? x : x?.msg)).filter(Boolean);
    return msgs.length ? msgs.join(" ") : fallback;
  }
  if (d && typeof d === "object") return d.msg || fallback;
  if (typeof e?.response?.data === "string") return e.response.data;
  return fallback;
}
